import React, { useState, useRef } from 'react';
import { addVersion } from '../api';
import SqlEditor from './SqlEditor';
import FormLabel from './FormLabel';
import ErrorBanner from './ErrorBanner';
import GradientButton from './GradientButton';
import GhostButton from './GhostButton';
import Spinner from './Spinner';

export default function AddVersionForm({ queryId, onAdded }) {
  const [sql, setSql]       = useState('');
  const [error, setError]   = useState('');
  const [saving, setSaving] = useState(false);
  const fileRef             = useRef(null);

  function handleFile(e) {
    const file = e.target.files[0]; if (!file) return;
    const reader = new FileReader();
    reader.onload = ev => setSql(ev.target.result);
    reader.readAsText(file); e.target.value = '';
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!sql.trim()) { setError('SQL content is required.'); return; }
    setSaving(true); setError('');
    try {
      await addVersion(queryId, { sql_content: sql });
      setSql('');
      onAdded();
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      <div>
        <FormLabel>SQL Query</FormLabel>
        <SqlEditor
          value={sql} onChange={e => setSql(e.target.value)}
          fileInputRef={fileRef} onFileUpload={handleFile}
          minRows={14}
        />
      </div>

      <ErrorBanner message={error} />

      <div className="flex items-center gap-3 pt-1">
        <GradientButton
          type="submit" disabled={saving}
          style={{ padding: '10px 20px', boxShadow: '0 4px 15px rgba(99,102,241,0.25)' }}
        >
          {saving
            ? <><Spinner className="w-4 h-4" /> Adding…</>
            : <>
                <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
                </svg>
                Add Version
              </>}
        </GradientButton>
        {sql && (
          <GhostButton type="button" onClick={() => { setSql(''); setError(''); }}>
            Clear
          </GhostButton>
        )}
      </div>
    </form>
  );
}
